export const REACTION_EMOJIS = [
	{ value: "\uD83D\uDC4D", emoji: "👍", label: "Curtir" },
	{ value: "\u2764\uFE0F", emoji: "❤️", label: "Amor" },
	{ value: "\uD83D\uDE02", emoji: "😂", label: "Risada" },
	{ value: "\uD83D\uDE2E", emoji: "😮", label: "Surpresa" },
	{ value: "\uD83D\uDE22", emoji: "😢", label: "Triste" },
	{ value: "\uD83D\uDE4F", emoji: "🙏", label: "Gratidão" },
];

const REACTION_BY_VALUE = REACTION_EMOJIS.reduce((map, item) => {
	map.set(item.value, item.emoji);
	return map;
}, new Map());

/** Normaliza emoji vindo da API (unicode, surrogate ou valor conhecido). */
export function normalizeEmoji(value) {
	if (value === null || value === undefined) return "";

	const raw = String(value).trim();
	if (!raw) return "";

	if (REACTION_BY_VALUE.has(raw)) {
		return REACTION_BY_VALUE.get(raw);
	}

	return raw;
}

export function isSameReaction(a, b) {
	if (!a || !b) return false;
	return normalizeEmoji(a) === normalizeEmoji(b);
}
